import Repository from "../Repository";

const resource = "/product/upper-limb-orthosis";

export default {
  async get(upper_limb_uuid) {
    return Repository.get(`${resource}/${upper_limb_uuid}`);
  },

  async createUpperLimb(payload) {
    return Repository.post(`${resource}`, payload);
  }
};
